import { Box, CircularProgress, Toolbar, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { runRestaurantClosedProcedure } from '../../../apis/runRestaurantClosedProcedure';
import { runRestaurantOpenProcedure } from '../../../apis/runRestaurantOpenProcedure';
import { traceAction } from '../../../libs/apiFetch';
import EDIT_ICON from '../../../assets/svg/edit-icon.svg';
import LOCATION_ICON from '../../../assets/svg/location-icon.svg';
import TABILIFE_LOGO_SVG from '../../../assets/svg/tabilife-logo.svg';
import CustomSwitch from '../../../components/Switch/Switch';
import db_config from '../../../configs/db_config';
import { LANG_TEXT } from '../../../constants/language';
import { NewOrderAlertsContext } from '../../../context/NewOrderAlerts';
import { useSettingsContext } from '../../../context/SettingsContext';
import usePermission from '../../../hooks/usePermission';
import { updateDoc } from '../../../libs/firestore-wrapper';
import { getCurrentSettings } from '../../../modals/order';
import CustomModal from '../../../pages/Dashboard/components/Modal/Modal';
import { AppBarCustom } from '../../MainLayout/AppBar/AppBar';
import Notifications from '../../MainLayout/AppBar/Notifications';
import { useStyles } from './styles';

export default function FoodTruckTopBar() {
  const classes = useStyles();

  const { currentSetting, setCurrentSetting } = useSettingsContext();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => {
    setOpenModal(false);
    setValue(currentSetting.region);
  };
  const [switchValue, setSwitchValue] = useState<boolean>(false);
  const [value, setValue] = useState<string>('');
  const { t } = useTranslation();
  const { notifications, markAsRead } = useContext(NewOrderAlertsContext);
  const [isLoading, setIsLoading] = useState(false);
  const { restaurantId, isAstrolabStore } = usePermission();

  useEffect(() => {
    setSwitchValue((currentSetting as any)?.restaurant_open_state === db_config.RESTAURANT_OPEN_STATE_OPENED ? true : false || false);
    setValue(currentSetting.region);
  }, [currentSetting]);

  const handleSwitchChange = async (isChecked: boolean) => {
    setIsLoading(true);
    const correlationId = traceAction('restaurant_open_state_toggle', {
      restaurantId,
      target: isChecked ? 'open' : 'closed',
    });
    try {
      setSwitchValue(isChecked);
      if (isChecked) {
        await runRestaurantOpenProcedure(restaurantId, correlationId);
      } else {
        await runRestaurantClosedProcedure(restaurantId, correlationId);
      }
      setCurrentSetting((prevData: any) => ({
        ...prevData,
        restaurant_open_state: isChecked ? db_config.RESTAURANT_OPEN_STATE_OPENED : db_config.RESTAURANT_OPEN_STATE_PREPARING,
      }));
    } catch (error) {
      console.error('Error updating restaurant state:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitRegion = (newValue: string) => {
    setValue(newValue);
    setCurrentSetting((prevData: any) => ({
      ...prevData,
      region: newValue,
    }));
    updateDoc(getCurrentSettings(restaurantId), { region: newValue });
    setOpenModal(false);
  };

  return (
    <AppBarCustom open={true} position="sticky">
      {isLoading && (
        <div className="loading-overlay">
          <CircularProgress />
        </div>
      )}
      <Toolbar className={classes.TollBarApp}>
        <img src={`${TABILIFE_LOGO_SVG}`} alt={'TABILIFE_LOGO_SVG'} loading="lazy" />
        <Box className={classes.HeaderStyles}>
          <Box className={classes.BoxSettings}>
            <img src={`${LOCATION_ICON}`} alt={'LOCATION_ICON'} loading="lazy" />
            <Typography fontSize={16} lineHeight={'24px'} color={'var(--Gray-400, #98A2B3)'}>
              {t(LANG_TEXT.LOCATION)}:
            </Typography>
            <Box className={classes.LocationText}>
              <span style={{ color: switchValue ? 'var(--Primary-700, #296C32)' : 'var(--Gray-400, #98A2B3)' }}>{switchValue ? `${value}` : '--'}</span>
              {switchValue && (
                <Box className={classes.ButtonLocation} onClick={handleOpenModal}>
                  <img src={EDIT_ICON} height={20} width={20} alt="EDIT_ICON" />
                </Box>
              )}
              <CustomModal value={value} setValue={setValue} open={openModal} handleClose={handleCloseModal} handleSubmitRegion={handleSubmitRegion} />
            </Box>
          </Box>
          <Box className={classes.BoxSettings}>
            <CustomSwitch onChange={handleSwitchChange} isChecked={switchValue} />
            <Typography fontSize={16} lineHeight={'24px'} color={'var(--Gray-400, #98A2B3)'}>
              {t(LANG_TEXT.STATUS)}:{' '}
              <span style={{ color: switchValue ? 'var(--Primary-700, #296C32)' : 'var(--Gray-400, #98A2B3)' }}>
                {switchValue ? `${t(LANG_TEXT.ONLINE)}` : `${t(LANG_TEXT.OFFLINE)}`}
              </span>
            </Typography>
          </Box>
          <Notifications notifications={isAstrolabStore ? notifications : []} markAsRead={markAsRead} />
        </Box>
      </Toolbar>
    </AppBarCustom>
  );
}
